import { createFileRoute } from "@tanstack/react-router"
import Onboarding from "@/pages/onboarding"
import { useEffect } from "react"
import { useLogout } from "students-api"

export const Route = createFileRoute("/onboarding/$token")({
  component: RouteComponent,
})

function RouteComponent() {
  const { logout } = useLogout()

  useEffect(() => {
    // Clear auth store on onboarding start
    logout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Onboarding />
}
